import React from 'react'
import { Button, Dropdown } from 'antd'
import { PaperClipOutlined, DownloadOutlined } from '@ant-design/icons'
import fileDownload from 'js-file-download'
import { useFetchSubmissionAttachmentsQuery, useLazyDownloadAttachmentQuery } from '../../../../../../../../store/apis/submission.api'

const AttachmentsDropdown = ({ submissionId, questionId }) => {
    const { data: attachments } = useFetchSubmissionAttachmentsQuery({ submissionId })
    const [downloadAttachment, { isFetching: isDownloading }] = useLazyDownloadAttachmentQuery()

    // Filter attachments for this specific question (or show all if questionId is null)
    const questionAttachments = attachments?.filter(attachment => 
        questionId ? attachment.questionId === questionId : true
    ) || []

    const handleDownload = async (attachmentId) => {
        try {
            const attachment = questionAttachments.find(attachment => attachment.id === attachmentId)
            const response = await downloadAttachment({ attachmentId })
            if ('data' in response) fileDownload(response.data, attachment.name)
        } catch (error) {
            console.error('Failed to download attachment:', error)
        }
    }

    if (questionAttachments.length === 0) return null 

    const menuItems = questionAttachments.map(attachment => ({
        key: attachment.id,
        icon: <DownloadOutlined />,
        label: attachment.name,
        onClick: () => handleDownload(attachment.id),
    }))

    return (
        <Dropdown
            menu={{ items: menuItems }}
            trigger={['click']}
            placement="bottomLeft"

        >
            <Button 
                type="text" 
                icon={<PaperClipOutlined />} 
                loading={isDownloading}
                size="small"
            >
                Attachments ({questionAttachments.length})
            </Button>
        </Dropdown>
    )
}

export default AttachmentsDropdown 